export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/array.js
// module id = 3777
// module chunks = 0